import * as React from "react";

interface StickyHeaderContextValue {
  hasStickyHeader: boolean;
  setHasStickyHeader: (v: boolean) => void;
  toggleSidebar: boolean;
}

export const StickyHeaderContext =
  React.createContext<StickyHeaderContextValue>({
    hasStickyHeader: false,
    setHasStickyHeader: () => {},
    toggleSidebar: true
  });
